module.exports = __webpack_public_path__ + "assets/img/transparency-1.649518fb.svg";